<template>
  <div class="animated fadeIn">
  <b-row>
    <b-col cols="12" lg="12">
      <b-card class="w-100" no-header>
        <template slot="header">
          <span class="mt-2">Eligibility Question : {{ details.number }}</span>
          <b-button @click="goBack" class="btn-sm pull-right">Back</b-button>
        </template>

        <b-card no-body id="data">

          <table class="table" v-if="details">
            <tbody>
                <tr v-for="(v, k, index) in details" :key="index" v-if="k !== 'id' && k !== 'insurers' && k !== 'types' && k !== 'type_display' ">
                    <th>{{ k|capitalize }}</th>
                    <td v-if="k === 'insurer'">{{ Insurer }}</td>
                    <td v-else-if="k === 'type'">{{ details.type_display }}</td>
                    <td v-else v-html="v">{{ v }}</td>
                </tr>
            </tbody>
        </table>

        </b-card>

        <template slot="footer">
          <b-button @click="goBack" class="float-left">Back</b-button>
          <b-button v-show="hasFullAccess" :to="{ name: 'EligibilityQuestionEdit', params: { id: details.id, product: $route.params.product } }" variant="outline-dark" class="float-right">Edit</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>

  </div>

</template>

<script>
  import axios from '../../../shared/axios/auth-no-loader'
  import Id from "bootstrap-vue/src/mixins/id";
  import base64url from "base64url";

  export default {
    name: 'EligibilityQuestion',
    components: {Id},
    props: {
      caption: {
        type: String,
        default: 'Eligibility Question Details'
      },
    },
    data: () => {
      return {
        details: {
         code: "",
         title: "",
         id: ""
        }
      }
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      getEligibilityQuestion() {
        let url = '';

        url = '/eligibility-questions/' + this.$route.params.id + '/?product=' + this.$route.params.product;

        axios.get(url).then(
          response => {
            this.details = response.data
          }
        ).catch(error => {
            // Unauthorised
            if (error.response.status === 401) {
              this.$store.dispatch('logout');
            }
            console.log('premium error');
            console.log(error.response)
          })
        return this.details
      }
    },
    computed: {
      hasFullAccess() {

        let access = ['full_admin',];

        let allowed = false;

        access.forEach(item => {
          if (this.$store.getters.getUserPermissions.includes(item)) {
            allowed = true
          }
        })

        return allowed

      },
      Insurer() {
        let insurer_text = ''

        if (this.details) {

          this.details.insurers.filter(item => {

              if (item.value === this.details.insurer) {
                insurer_text = item.text
              }
            })
        }

        return insurer_text
      }
    },
    mounted() {
      this.getEligibilityQuestion()
    },
    watch: {
      $route(to, from) {
        // react to route changes...
        this.$router.replace(to.fullPath).catch(error => {
          console.log(error)
        }).then(
          this.getEndorsement()
        );

      }
    }
  }
</script>

<style>

  #data .card-header {
    padding-top: 1.5rem;
  }
</style>
